import { cn } from '@sparkai/utils'

import { Icon, IconsName } from '../Icon'

export type RadialIconProps = {
  variant: 'blue' | 'red' | 'gray'
  icon: IconsName
}

export function RadialIcon({ variant, icon }: RadialIconProps) {
  let outerColor, innerColor, iconColor

  switch (variant) {
    case 'blue':
      outerColor = 'bg-brand-blue-50'
      innerColor = 'bg-brand-blue-100'
      iconColor = 'text-brand-blue-500'
      break
    case 'red':
      outerColor = 'bg-brand-red-50'
      innerColor = 'bg-brand-red-100'
      iconColor = 'text-brand-red-500'
      break
    case 'gray':
      outerColor = 'bg-brand-gray-100'
      innerColor = 'bg-brand-gray-200'
      iconColor = 'text-brand-gray-500'
      break
  }

  return (
    <div
      className={cn(
        'flex aspect-square h-[60px] w-[60px] items-center justify-center rounded-full',
        outerColor
      )}
    >
      <div
        className={cn('flex aspect-square h-10 w-10 items-center justify-center rounded-full', innerColor)}
      >
        <Icon name={icon} className={iconColor} />
      </div>
    </div>
  )
}
